<template>
    <VListSubheader>Theme</VListSubheader>

    <VItemGroup mandatory :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
        <VCol class="py-1 px-0" v-for="({ icon, text }) in items" :key="text" cols="12">
            <VItem v-slot="{ isSelected, toggle }" :value="text">
                <VBtn :ref="'item-' + text" :color="isSelected ? 'primary' : `grey-${isDark ? 'darken' : 'lighten'}-4`"
                    :append-icon="icon" class="px-4 rounded-lg text-capitalize justify-space-between text-body-2" block
                    variant="flat" size="large" @click="toggle">
                    {{ text }}
                </VBtn>
            </VItem>
        </VCol>
    </VItemGroup>
</template>

<script setup lang="ts">
import { useTheme } from 'vuetify';
import { computed } from 'vue';
import type { PropType } from 'vue';

defineProps({
    title: String,
    modelValue: null,
    items: Array as PropType<{ icon: string, text: string }[]>,
})

defineEmits({
    'update:modelValue': (value: string) => true,
})
const theme = useTheme();
const isDark = computed(() => theme.global.current.value.dark);

</script>

<style lang="sass">
    .v-card--group::before
      border-radius: inherit
  </style>